import Vue from 'vue'
import Router from 'vue-router'
import Home from 'pages/home/home'
import Quality from 'pages/quality/quality'
import General from 'pages/quality/general.vue'
import Farmland from 'pages/quality/farmland.vue'
import Soil from 'pages/quality/soil.vue';
import Environment from 'pages/quality/environment';
import Transaction from 'pages/transaction/transaction'
import Area from 'pages/transaction/area.vue';
import Quantity from 'pages/transaction/quantity.vue';
import Price from 'pages/transaction/price.vue';
import Worth from 'pages/transaction/worth.vue';
import Proportion from 'pages/transaction/proportion.vue';
import Whereabouts from 'pages/transaction/whereabouts.vue';
import Pollute from 'pages/pollute/pollute.vue';

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',  //路由默认跳转
      redirect: 'home'
    }, {
      path: '/home',
      name: 'home',
      component: Home,
      redirect: "/home/quality",
      children: [
        {
          path: 'quality',
          name: 'quality',
          component: Quality,
          meta: {
            title: '耕地质量-耕地利用大数据'
          },
          redirect: '/home/quality/general',
          children: [
            {
              path: 'general',
              name: 'general',
              component: General,
              meta: {
                title: '耕地质量概况分析-耕地质量-耕地利用大数据'
              }
            },{
              path: 'farmland',
              name: 'farmland',
              component: Farmland,
              meta: {
                title: '高标准农田分析-耕地质量-耕地利用大数据'
              }
            },{
              path: 'soil',
              name: 'soil',
              component: Soil,
              meta: {
                title: '耕地土壤质量分析-耕地质量-耕地利用大数据'
              }
            },{
              path: 'environment',
              name: 'environment',
              component: Environment,
              meta: {
                title: '耕地环境质量分析-耕地质量-耕地利用大数据'
              }
            },
          ]
        },
        {
          path: 'transaction',
          name: 'transaction',
          component: Transaction,
          mata: {
            title: '土地流转-耕地利用大数据'
          },
          redirect: '/home/transaction/area',
          children: [
            {
              path: 'area',
              name: 'area',
              component: Area,
              meta: {
                title: '流转面积分析-土地流转-耕地利用大数据'
              }
            },{
              path: 'quantity',
              name: 'quantity',
              component: Quantity,
              meta: {
                title: '流转数量分析-土地流转-耕地利用大数据'
              }
            },{
              path: 'price',
              name: 'price',
              component: Price,
              meta: {
                title: '流转价格分析-土地流转-耕地利用大数据'
              }
            },{
              path: 'worth',
              name: 'worth',
              component: Worth,
              meta: {
                title: '土地价值评估指数分析-土地流转-耕地利用大数据'
              }
            },{
              path: 'proportion',
              name: 'proportion',
              component: Proportion,
              meta: {
                title: '流转比例分析-土地流转-耕地利用大数据'
              }
            },{
              path: 'whereabouts',
              name: 'whereabouts',
              component: Whereabouts,
              meta: {
                title: '流转去向及类型分析-土地流转-耕地利用大数据'
              }
            },
          ]
        },
      ],
    },
    {
      path: '/pollute',
      name: 'pollute',
      component: Pollute,
      meta: {
        title: '畜禽污染处理大数据'
      }
    }
  ],
  linkActiveClass: 'active'
})
/*router.beforeEach((to, from, next) => {
  if (to.path === '/login' || localStorage.getItem('accessToken')) {
    next()
  } else if (!localStorage.getItem('accessToken')) {
    next({path: '/'})
  }
})*/
// 导航确认以后才去改变title
router.afterEach((to) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js